module.exports = __webpack_public_path__ + "static/added-6faf9d9177e98b2e47eacbc1c7e86c83.jpeg";